import React from "react";
import PropTypes from "prop-types";

import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { isEmpty } from "../utils/helpers";

const SplitButton = ({ options = [], primaryLabel, primaryIcon, onClick, ...rest }) => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleClick = ({ index }) => {
    const idx = !isEmpty(index) ? index : 0;
    onClick && onClick({ type: options[idx] });
  };

  const handleMenuItemClick = (event, index) => {
    handleClick({ index });
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const optionsLabel = !isEmpty(options) ? options.map(e => e.toUpperCase()) : [];

  if (isEmpty(options)) return <div></div>;

  return (
    <div>
      <ButtonGroup variant="contained" color="primary" aria-label="split button" {...rest}>
        <Button onClick={handleClick} startIcon={primaryIcon}>
          {primaryLabel ? primaryLabel.toUpperCase() : optionsLabel[0]}
        </Button>
        <Button
          ref={anchorRef}
          color="primary"
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}>
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal={false}
        placement="top">
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom"
            }}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  {optionsLabel.map((option, index) => (
                    <MenuItem key={option} onClick={event => handleMenuItemClick(event, index)}>
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

SplitButton.prototype = {
  options: PropTypes.array,
  onClick: PropTypes.func,
  primaryIcon: PropTypes.element
};

export default SplitButton;
